<div class="row">
    <div class="col-md-1">
        <div [ngClass]="iconClass"></div>
    </div>
    <div class="col-md-11">
        <ng-content></ng-content>
    </div>
</div>
